// Banner Slider
function initBannerSlider(el) {
  if (!window.Swiper || el.swiper) return;

  var slideCount = parseInt(el.dataset.slideCount, 10) || 0;
  var autoplay = el.dataset.autoplay === 'true';
  var autoplaySpeed = parseInt(el.dataset.autoplaySpeed, 10) || 5000;
  var effect = el.dataset.effect || 'fade';
  var showArrows = el.dataset.showArrows === 'true';
  var showDots = el.dataset.showDots === 'true';

  var config = {
    loop: slideCount > 1,
    effect: effect,
    speed: 600,
    grabCursor: true,
    autoHeight: true,
    a11y: { enabled: true }
  };

  if (effect === 'fade') {
    config.fadeEffect = { crossFade: true };
  }

  if (slideCount > 1) {
    if (showDots) {
      config.pagination = {
        el: el.querySelector('.swiper-pagination'),
        clickable: true
      };
    }

    if (showArrows) {
      config.navigation = {
        nextEl: el.querySelector('.banner-button-next'),
        prevEl: el.querySelector('.banner-button-prev')
      };
    }
  }

  if (autoplay && slideCount > 1) {
    config.autoplay = {
      delay: autoplaySpeed,
      disableOnInteraction: false,
      pauseOnMouseEnter: true
    };
  }

  new Swiper(el, config);
}

function initAllBannerSliders(root) {
  var scope = root || document;
  scope.querySelectorAll('.banner-slider.swiper').forEach(initBannerSlider);
}

if (window.Swiper) {
  initAllBannerSliders();
} else {
  window.addEventListener('load', function () {
    initAllBannerSliders();
  });
}

document.addEventListener('shopify:section:load', function (event) {
  initAllBannerSliders(event.target);
});


// 
// Shop by category
function initShopCategorySlider(el) {
  if (!window.Swiper || el.swiper) return;

  var slideCount = parseInt(el.dataset.slideCount, 10) || 0;
  var autoplay = el.dataset.autoplay === 'true';
  var autoplaySpeed = parseInt(el.dataset.autoplaySpeed, 10) || 5000;
  var showArrows = el.dataset.showArrows === 'true';
  var showDots = el.dataset.showDots === 'true';
  var slidesDesktop = parseInt(el.dataset.slidesDesktop, 10) || 4;
  var slidesTablet = parseInt(el.dataset.slidesTablet, 10) || 3;
  var slidesMobile = parseInt(el.dataset.slidesMobile, 10) || 1;

  var config = {
    slidesPerView: slidesMobile,
    spaceBetween: 16,
    loop: slideCount > slidesDesktop,
    grabCursor: true,
    a11y: { enabled: true },
    breakpoints: {
      750: {
        slidesPerView: slidesTablet,
        spaceBetween: 20
      },
      990: {
        slidesPerView: slidesDesktop,
        spaceBetween: 24
      }
    }
  };

  if (slideCount > 1) {
    if (showDots) {
      config.pagination = {
        el: el.querySelector('.category-pagination'),
        clickable: true
      };
    }

    if (showArrows) {
    var wrap =  el.parentElement;
      config.navigation = {
        nextEl: wrap.querySelector('.category-button-next'),
        prevEl: wrap.querySelector('.category-button-prev')
      };
    }
  }

  if (autoplay && slideCount > 1) {
    config.autoplay = {
      delay: autoplaySpeed,
      disableOnInteraction: false,
      pauseOnMouseEnter: true
    };
  }

  new Swiper(el, config);
}

function initAllShopCategorySliders(root) {
  var scope = root || document;
  scope.querySelectorAll('.shop-category__slider.swiper').forEach(initShopCategorySlider);
}

if (window.Swiper) {
  initAllShopCategorySliders();
} else {
  window.addEventListener('load', function () {
    initAllShopCategorySliders();
  });
}

document.addEventListener('shopify:section:load', function (event) {
  initAllShopCategorySliders(event.target);
});


// 
// Testimonials
function initTestimonialsSlider(el) {
  if (!window.Swiper || el.swiper) return;

  var slideCount = parseInt(el.dataset.slideCount, 10) || 0;
  var autoplay = el.dataset.autoplay === 'true';
  var autoplaySpeed = parseInt(el.dataset.autoplaySpeed, 10) || 5000;
  var showArrows = el.dataset.showArrows === 'true';
  var showDots = el.dataset.showDots === 'true';
  var slidesDesktop = parseInt(el.dataset.slidesDesktop, 10) || 3;
  var slidesTablet = parseInt(el.dataset.slidesTablet, 10) || 2;
  var slidesMobile = parseInt(el.dataset.slidesMobile, 10) || 1;

  var config = {
    slidesPerView: slidesMobile,
    spaceBetween: 16,
    loop: true,
    grabCursor: true,
    a11y: { enabled: true },
    autoHeight: true,
    breakpoints: {
      750: {
        slidesPerView: slidesTablet,
        spaceBetween: 20
      },
      990: {
        slidesPerView: slidesDesktop,
        spaceBetween: 24
      }
    }
  };

  if (slideCount > 1) {
    if (showDots) {
      config.pagination = {
        el: el.querySelector('.testimonial-pagination'),
        clickable: true
      };
    }

    if (showArrows) {
        var wrap = el.closest('.testimonials__slider-wrap') || el.parentElement;
        config.navigation = {
            nextEl: wrap.querySelector('.testimonial-button-next'),
            prevEl: wrap.querySelector('.testimonial-button-prev')
        };
    }
  }

  if (autoplay && slideCount > 1) {
    config.autoplay = {
      delay: autoplaySpeed,
      disableOnInteraction: false,
      pauseOnMouseEnter: true
    };
  }

  new Swiper(el, config);
}

function initAllTestimonialsSliders(root) {
  var scope = root || document;
  scope.querySelectorAll('.testimonials__slider.swiper').forEach(initTestimonialsSlider);
}

if (window.Swiper) {
  initAllTestimonialsSliders();
} else {
  window.addEventListener('load', function () {
    initAllTestimonialsSliders();
  });
}

document.addEventListener('shopify:section:load', function (event) {
  initAllTestimonialsSliders(event.target);
});


// CUSTOM COLLECTION FAQ SECTION //

document.addEventListener('DOMContentLoaded', function () {
  var accordions = document.querySelectorAll('.cc-faq-accordion');

  accordions.forEach(function (accordion) {
    var questions = accordion.querySelectorAll('.cc-faq-item__question');

    questions.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        var answer = document.getElementById(btn.getAttribute('aria-controls'));

        // Close all other items in this accordion (single-open behavior)
        questions.forEach(function (otherBtn) {
          if (otherBtn !== btn) {
            otherBtn.setAttribute('aria-expanded', 'false');
            var otherAnswer = document.getElementById(otherBtn.getAttribute('aria-controls'));
            if (otherAnswer) otherAnswer.setAttribute('hidden', '');
          }
        });

        // Toggle current item
        btn.setAttribute('aria-expanded', String(!expanded));
        if (expanded) {
          answer.setAttribute('hidden', '');
        } else {
          answer.removeAttribute('hidden');
        }
      });
    });
  });
});



// Testimonial Section

document.addEventListener('DOMContentLoaded', function () {

  const testimonialContents = document.querySelectorAll('.testimonials__content');

  testimonialContents.forEach(function (content) {

    // Check whether the content exceeds the collapsed height
    function checkOverflow() {

      // Remove existing button before checking
      const existingButton = content.parentElement.querySelector('.testimonial-read-more');

      if (existingButton) {
        existingButton.remove();
      }

      // Reset state for accurate measurement
      content.classList.remove('is-expanded');

      // Check if text is actually overflowing
      if (content.scrollHeight > content.clientHeight + 1) {

        const button = document.createElement('button');

        button.type = 'button';
        button.className = 'testimonial-read-more';
        button.textContent = 'Read More';

        button.addEventListener('click', function () {

          if (content.classList.contains('is-expanded')) {

            // Collapse
            content.classList.remove('is-expanded');
            button.textContent = 'Read More';

            // Return scroll position to top
            content.scrollTop = 0;

          } else {

            // Expand
            content.classList.add('is-expanded');
            button.textContent = 'Read Less';

          }

        });

        content.insertAdjacentElement('afterend', button);
      }
    }

    // Initial check
    checkOverflow();

    // Recheck when browser/window size changes
    window.addEventListener('resize', function () {
      checkOverflow();
    });

  });

});
